import { AxiosInstance } from "axios"
import { ServiceResponse } from "../../core/api/apiTypes"
import {
    ChangePasswordParams,
    ChangeUserAccountResponse,
    ChangeAccountResponse,
    GetUserAccountsResponse,
    ConfirmEmailParams,
    GetUserAccountsParams,
} from "./profileTypes"

export enum ProfileQuery {
    CHANGE_USER_ACCOUNT = "change-user-account",
}

export async function changePassword(
    params: ChangePasswordParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const response = await axios.post(
        "/me/changePassword",
        {
            ...params,
        },
        {
            signal,
        },
    )
    return response.data
}

export async function changeUserAccount(
    {},
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ChangeUserAccountResponse> {
    const response = await axios.get("/me/userAccounts", {
        signal,
    })
    return response.data
}

export async function sendEmailConfirmation(
    {},
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const response = await axios.get("/me/confirmationEmail", {
        signal,
    })
    return response.data
}

export async function changeAccount(
    { uid }: { uid: string },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ChangeAccountResponse> {
    const response = await axios.post(
        "/authenticate/changeAccount",
        {
            switchAccountTo: {
                uid,
            },
        },
        {
            signal,
        },
    )
    return response.data
}

export async function confirmEmailAddress(
    { userId, otp }: ConfirmEmailParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<GetUserAccountsResponse> {
    const response = await axios.post(
        `/users/${userId}/confirmEmail?otp=${otp}`,
        {},
        {
            signal,
        },
    )
    return response.data
}
